<template>
  <el-container>
    <el-header class="header theme_background_color">
      <HeaderItem />
    </el-header>
    <el-main class="main">
      <HomeItem class="theme_background_color">
        <el-row :gutter="10" class="content-div">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="item-content">
              <div class="animated fadeInLeft item-title item-child">
                <p class="item-title-p1 theme_font_color">我的物品</p>
                <p class="item-title-p2 theme_font_hover_color">记录物品数据的 一体化工具</p>
                <img class="hover-text" @click="hanldClick('https://apps.apple.com/cn/app/id1546687449')" :src="isLightTheme ? appStoreImg : appStoreDarkImg" />
                <span class="android-text theme_font_color">「Android 版本前往各家应用商店下载」</span>
              </div>
            </div>
            <div class="juzheng juzheng-left">
              <img :src="juzhengImg" />
            </div>
            <div class="textimg textimgitem"></div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="item-content">
              <div class="item-child">
                <img class="item-child-img sych-img animated fadeInRight" :src="isLightTheme ? shouyechahuaImg : shouyechahuaDarkImg" />
              </div>
            </div>
            <div class="juzheng juzheng-right">
              <img :src="juzhengImg" />
            </div>
          </el-col>
        </el-row>
      </HomeItem>
      <HomeItem :icon="itemImg1" class="theme_background1_color">
        <el-row :gutter="10" class="content-div content-item1">
          <el-col :xs="24" :sm="24" :md="7" :lg="9" :xl="9">
            <div class="item-content">
              <div class="item1-child">
                <img class="animated bounceInDown" :src="isLightTheme ? enthusiasticImg : enthusiasticDarkImg" />
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="17" :lg="15" :xl="15">
            <div class="item-content">
              <div class="carousel-div">
                <el-carousel class="carousel" trigger="click" height="380px" :interval="5000">
                  <el-carousel-item v-for="item in 4" :key="item">
                    <img class="item-child-img pm-img" :src="isLightTheme ? paimingImg : paimingDarkImg" />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </el-col>
        </el-row>
      </HomeItem>
      <HomeItem :icon="itemImg2" title="来自用户的声音" class="theme_background_color">
        <el-row :gutter="10" class="content-div content-item2">
          <div class="juzheng juzheng-left1">
            <img :src="juzhengImg" />
          </div>
          <div class="juzheng juzheng-right1">
            <img :src="juzhengImg" />
          </div>
          <el-col :span="24" class="item-content commentScrollbar commentScrollbar-top">
            <CommentDiv v-for="(it, index) in commentList1" :key="index" :content="it.comment" :user="it.nickname" :icon="isLightTheme ? yinghaoImg : yinghaoDarkImg" />
          </el-col>
          <el-col :span="24" class="item-content commentScrollbar commentScrollbar-buttom">
            <CommentDiv v-for="(it, index) in commentList2" :key="index" :content="it.comment" :user="it.nickname" :icon="isLightTheme ? yinghaoImg : yinghaoDarkImg" />
          </el-col>
        </el-row>
      </HomeItem>
      <HomeItem :icon="itemImg3" title="尽享 APP 精彩" class="theme_background_color">
        <el-row :gutter="10" class="content-div content-item3 content-item-child1">
          <div class="textimg textimgitem1"></div>
          <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="12" style="min-height: 620px">
            <div v-show="itemchild1Show" class="animated fadeInUp item-content item-content-img">
              <img class="item-child-img gqtx-img" :src="isLightTheme ? guoqitixingImg : guoqitixingDarkImg" />
              <div class="yuanImg big"></div>
              <div class="yuanImg small"></div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="12">
            <div class="item-content">
              <div class="item-content-text">
                <p class="theme_font_color">
                  过期提醒
                  <br />物品过期前提醒
                </p>
                <p class="theme_font_color">内容内容内容内容内容内容内容内容 内容内容内容内容内容内容</p>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content-div content-item3 content-item-child2">
          <div class="textimg textimgitem2"></div>
          <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="12">
            <div class="item-content">
              <div class="item-content-text">
                <p class="theme_font_color">
                  进度条提示
                  <br />随时查看购买时长
                </p>
                <p class="theme_font_color">内容内容内容内容内容内容内容内容 内容内容内容内容内容内容</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="12">
            <div class="item-content item-content-img">
              <img v-show="itemchild2Show" class="animated fadeInUp item-child-img jdt-img" :src="isLightTheme ? jingdutiaoImg : jindutiaoDarkImg" />
              <div class="yuanImg big"></div>
              <div class="yuanImg small"></div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content-div content-item3 content-item-child1">
          <div class="textimg textimgitem1"></div>
          <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="12">
            <div class="item-content item-content-img">
              <img v-show="itemchild3Show" class="animated fadeInUp item-child-img fl-img" :src="isLightTheme ? fenleiImg : fenleiDarkImg" />
              <div class="yuanImg big"></div>
              <div class="yuanImg small"></div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="12">
            <div class="item-content">
              <div class="item-content-text">
                <p class="theme_font_color">分类清晰</p>
                <p class="theme_font_color">内容内容内容内容内容内容内容内容 内容内容内容内容内容内容</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </HomeItem>
      <HomeItem :icon="itemImg4" title="我的物品" :background="isLightTheme ? huxingdiImg : huxingdiDarkImg" class="theme_background_color">
        <el-row class="content-div content-item4">
          <el-col :span="24" class="item-content">
            <div class="juzheng juzheng-left2">
              <img :src="juzhengImg" />
            </div>
            <div class="juzheng juzheng-right2">
              <img :src="juzhengImg" />
            </div>
            <div class="textimg textimgitem3"></div>
            <div class="item4-child">
              <p class="theme_font_hover_color">记录物品数据的一体化工具</p>
              <div>
                <img class="hover-text" @click="hanldClick('https://apps.apple.com/cn/app/id1423132930')" :src="isLightTheme ? appStoreImg : appStoreDarkImg" />
              </div>
              <div>
                <img :src="isLightTheme ? zhaoshouImg : zhaoshouDarkImg" />
              </div>
            </div>
          </el-col>
        </el-row>
      </HomeItem>
    </el-main>
    <el-footer class="footer theme_background_color">
      <FooterItem />
    </el-footer>
  </el-container>
</template>

<script>
import itemImg1 from '../../assets/images/lightImgs/icon_trophy.svg'
import itemImg2 from '../../assets/images/lightImgs/icon_laba.svg'
import itemImg3 from '../../assets/images/lightImgs/zan.svg'
import itemImg4 from '../../assets/images/lightImgs/logoicon.png'
import appStoreImg from '../../assets/images/lightImgs/btn_AppStore.svg'
import shouyechahuaImg from '../../assets/images/lightImgs/shouyechahua.png'
import juzhengImg from '../../assets/images/lightImgs/dots(2).svg'
import paimingImg from '../../assets/images/lightImgs/paiming.png'
import enthusiasticImg from '../../assets/images/lightImgs/Enthusiastic.svg'
import guoqitixingImg from '../../assets/images/lightImgs/guoqitixing.png'
import jingdutiaoImg from '../../assets/images/lightImgs/jingdutiao.png'
import fenleiImg from '../../assets/images/lightImgs/fenlei.png'
import huxingdiImg from '../../assets/images/lightImgs/huxingdi.svg'
import zhaoshouImg from '../../assets/images/lightImgs/zhaoshou.svg'
import dayuanImg from '../../assets/images/lightImgs/dayuan.svg'
import appLogo from '../../assets/images/lightImgs/logo_header.png'
import yinghaoImg from '../../assets/images/lightImgs/yinghao.svg'

import appStoreDarkImg from '../../assets/images/darkImgs/btn_AppStoredark.svg'
import shouyechahuaDarkImg from '../../assets/images/darkImgs/shouyechahuadark.png'
import paimingDarkImg from '../../assets/images/darkImgs/paimingdarkImg.png'
import enthusiasticDarkImg from '../../assets/images/darkImgs/EnthusiasticDark.svg'
import yinghaoDarkImg from '../../assets/images/darkImgs/yinghaodark.svg'
import guoqitixingDarkImg from '../../assets/images/darkImgs/guoqitixingdark.png'
import huxingdiDarkImg from '../../assets/images/darkImgs/huxingdidark.svg'
import jindutiaoDarkImg from '../../assets/images/darkImgs/jindutiaodark.png'
import fenleiDarkImg from '../../assets/images/darkImgs/fenleidark.png'
import zhaoshouDarkImg from '../../assets/images/darkImgs/zhaoshoudark.svg'

import empty1 from '../../assets/empty.svg'
import { mapMutations, mapState } from 'vuex'
import HomeItem from '../../components/HomeItem'
import HeaderItem from '../../components/HeaderItem'
import FooterItem from '../../components/FooterItem'
import CommentDiv from '../../components/CommentDiv'
import { getCommentAPI } from './homeApi'
export default {
  name: 'home',
  computed: {
    ...mapState(['theme']),
    isLightTheme() {
      document.getElementsByTagName('body')[0].style.backgroundColor =
        this.$store.state.theme === 'light' ? '#fff' : 'rgba(34, 34, 34, 1)'
      return this.$store.state.theme === 'light' ? true : false
    },
  },

  data() {
    return {
      appLogo,
      empty1,
      itemImg1,
      itemImg2,
      appStoreImg,
      shouyechahuaImg,
      juzhengImg,
      paimingImg,
      enthusiasticImg,
      itemImg4,
      guoqitixingImg,
      yinghaoImg,
      jingdutiaoImg,
      fenleiImg,
      itemImg3,
      huxingdiImg,
      zhaoshouImg,
      dayuanImg,
      appStoreDarkImg,
      shouyechahuaDarkImg,
      paimingDarkImg,
      enthusiasticDarkImg,
      yinghaoDarkImg,
      guoqitixingDarkImg,
      huxingdiDarkImg,
      jindutiaoDarkImg,
      fenleiDarkImg,
      zhaoshouDarkImg,
      itemchild1Show: false,
      itemchild2Show: false,
      itemchild3Show: false,
      commentList1: [],
      commentList2: [],
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
    let media = window.matchMedia('(prefers-color-scheme: dark)')
    if (media.matches) {
      this.changeTheme('dark')
    } else {
      this.changeTheme('light')
    }
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    HomeItem,
    HeaderItem,
    FooterItem,
    CommentDiv,
  },
  beforeMount() {
    getCommentAPI()
      .then((res) => {
        // eslint-disable-next-line no-unused-vars
        let index = 0
        if (res.result.length > 10) {
          index =
            res.result.length % 2 === 0
              ? res.result.length / 2
              : (res.result.length - 1) / 2
          this.commentList1 = res.result.slice(0, index)
          this.commentList2 = res.result.slice(index, res.result.length)
        } else {
          this.commentList1 = res.result
          this.commentList2 = res.result
        }
      })
      .catch((err) => console.log(err))
  },
  methods: {
    openUrl(url) {
      window.open(url, '_blank')
    },
    ...mapMutations(['changeTheme']),
    change() {
      // 手动触发
      console.log(this.theme)
      const theme = this.theme === 'light' ? 'dark' : 'light'
      this.changeTheme(theme)
    },
    handleScroll() {
      let scrollHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop // 滚动条的滚动行程
      if (scrollHeight > 1900) {
        this.itemchild1Show = true
      }
      if (scrollHeight > 2500) {
        this.itemchild2Show = true
      }
      if (scrollHeight > 3200) {
        this.itemchild3Show = true
      }
    },
    hanldClick(url) {
      window.open(url, '_blank')
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true) //  离开页面清除（移除）滚轮滚动事件
  },
}
</script>

<style lang="less" scoped>
.main {
  padding: 0 !important;
}
.footer {
  height: 160px !important;
}
.content-div {
  position: relative;
}
.item-child {
  max-width: 424px;
  position: relative;
}
.item-title {
  float: right;
  .item-title-p1 {
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 42px;
    letter-spacing: 1px;
  }
  .item-title-p2 {
    font-size: 46px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 58px;
    letter-spacing: 6px;
  }
}
.juzheng-left {
  bottom: 107px;
  left: 0;
}
.juzheng-right {
  top: -42px;
  right: 0;
}
.juzheng-left1 {
  top: 0;
  left: 0;
}
.juzheng-right1 {
  right: 0;
  bottom: 0;
}
.juzheng-left2 {
  bottom: -12px;
  left: 0;
}
.juzheng-right2 {
  top: -12px;
  right: 0;
}
.juzheng {
  width: 111px;
  height: 111px;
  position: absolute;
  img {
    width: 100%;
    height: 100%;
  }
}
.textimg {
  position: absolute;
  background: url(../../assets/images/lightImgs/text.png) no-repeat;
  background-size: 100% 100%;
  width: 1080px;
  height: 107px;
}
.textimgitem {
  left: 0;
  bottom: 0;
}
.textimgitem1 {
  right: 0;
  top: 0;
}
.textimgitem2 {
  left: 0;
  top: 0;
}
.textimgitem3 {
  left: 105px;
  bottom: 0;
}
.item1-child {
  text-align: right;
  text-align: -webkit-right

}
.carousel-div {
  margin-top: 84px;
}
.carousel {
  width: 820px;
  text-align: center;
  text-align: -webkit-center;

}
.content-item1 {
  padding-bottom: 30px;
}
.content-item2 {
  .item-content {
    padding: 20px 0;
  }

  .item-content:first-child {
    margin-top: 40px;
  }
  .item-content:last-child {
    margin-bottom: 50px;
  }
}
.commentScrollbar {
  white-space: nowrap;
  // overflow-x: auto;
  // display: flex;
  flex-flow: row nowrap;
  -webkit-box-pack: center;
  place-content: flex-start center;
  -webkit-box-align: stretch;
  align-items: stretch;
  position: relative;
  right: 0px;
  display: flex;
  display: -webkit-flex;
}
.commentScrollbar-top {
  animation: 100s wordsLoop linear infinite normal;
}
.commentScrollbar-buttom {
  animation: 100s wordsLoopbuttom linear infinite normal;
}
@keyframes wordsLoop {
  0% {
    transform: translateX(0%);
    -webkit-transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
}

@-webkit-keyframes wordsLoop {
  0% {
    transform: translateX(0%);
    -webkit-transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
}
@keyframes wordsLoopbuttom {
  0% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
  100% {
    transform: translateX(0%);
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes wordsLoopbuttom {
  0% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
  100% {
    transform: translateX(0%);
    -webkit-transform: translateX(0%);
  }
}
.light_theme {
  .commentScrollbar::-webkit-scrollbar {
    width: 1px;
    height: 20px;
    display: none;
  }
  .commentScrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #fff2df;
  }
  .commentScrollbar::-webkit-scrollbar-track {
    background: #fffdf8;
  }
}
.dark_theme {
  .textimg {
    background: url(../../assets/images/darkImgs/textdark.png) no-repeat !important;
    background-size: 100% 100%;
  }
  .commentScrollbar {
    // white-space: nowrap;
    // overflow-x: auto;
  }
  .commentScrollbar::-webkit-scrollbar {
    width: 1px;
    height: 20px;
    display: none;
  }
  .commentScrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #363535;
  }
  .commentScrollbar::-webkit-scrollbar-track {
    background: #262626;
  }
}

.content-item3 {
  margin: 46px 0;
  .item-content {
    position: relative;
  }
  .item-content-text {
    position: relative;
    width: 300px;
    top: 180px;
    margin: 0 56px 0 68px;
    p:first-child {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 45px;
    }
    p:last-child {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      opacity: 0.7;
      line-height: 25px;
    }
  }

  .big {
    width: 139px;
    height: 139px;
  }
  .small {
    width: 43px;
    height: 43px;
  }
  .yuanImg {
    background: url(../../assets/images/lightImgs/dayuan.svg) no-repeat;
    background-size: 100% 100%;
    position: absolute;
  }
}
.content-item-child1 {
  .item-content-img {
    text-align: right;
    text-align: -webkit-right;
    position: relative;
    img {
      z-index: 999;
      position: relative;
    }
    .big {
      right: 460px;
      bottom: 10px;
    }
    .small {
      right: 0;
      top: 180px;
    }
  }
}
.content-item-child2 {
  text-align: right;
  text-align: -webkit-right;
  .item-content-img {
    text-align: left;
    position: relative;
    img {
      z-index: 999;
      position: relative;
    }
    .big {
      left: 460px;
      bottom: 10px;
    }
    .small {
      left: 0;
      top: 180px;
    }
  }
  .item-content-text {
    display: inline-block;
    text-align: left;
  }
}
.content-item4 {
  .item4-child {
    text-align: center;
    text-align: -webkit-center;
  }
  img {
    position: relative;
  }
  p {
    font-size: 46px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 58px;
    letter-spacing: 12px;
    position: relative;
  }
}
.android-text {
  display: inline-block;
  line-height: 28px;
  margin-left: 10px;
}
.hover-text {
  cursor: pointer;
}
.sych-img {
  width: 424px;
}
.pm-img {
  width: 720px;
}
.gqtx-img {
  width: 551px;
}
.jdt-img {
  width: 545px;
}
.fl-img {
  width: 543px;
}
</style>
<style lang="less">
.dark-theme > .content-item2 > .item-content::-webkit-scrollbar-track {
  background: #262727 !important;
}
.dark-theme > .content-item2 > .item-content::-webkit-scrollbar-thumb {
  background: #3e3e3e !important;
}
@media only screen and (max-width: 620px) {
  .header,
  .footer {
    padding: 0 20px !important;
  }
  .item-child {
    width: 100% !important;
    max-width: 100% !important;
    text-align: center !important;
    text-align: -webkit-center;
    .item-child-img {
      width: 100% !important;
    }
  }
  .item1-child {
    text-align: center !important;
    text-align: -webkit-center
  }
  .carousel {
    width: 100% !important;
    img {
      width: 100% !important;
    }
  }
  .content-item3 {
    .item-content-img {
      text-align: center !important;
      img {
        width: 100% !important;
      }
    }
    .item-content-text {
      position: unset !important;
      width: 100% !important;
      text-align: center !important;
      margin-left: 0 !important;
    }
  }
  .content-item-child2 {
    .item-content-img {
      text-align: center !important;
    }
  }
  .android-text {
    width: 100%;
    margin-top: 10px;
  }
  //   .commentScrollbar-top {
  //   animation: 100s wordsLoop linear infinite normal !important;
  // }
  // .commentScrollbar-buttom {
  //   animation: 100s wordsLoopbuttom linear infinite normal !important;;
  // }
}

@media only screen and (min-width: 621px) and (max-width: 992px) {
  .header,
  .footer {
    padding: 0 60px !important;
  }
  .item-title {
    float: none !important;
  }
  .item-child {
    position: relative;
    left: 50%;
    margin-left: -212px;
  }
  .item1-child {
    text-align: center !important;
    text-align: -webkit-center
  }
  .carousel {
    width: 100% !important;
  }
  .content-item3 {
    .item-content-img {
      text-align: center !important;
    }
    .item-content-text {
      position: unset !important;
      width: 100% !important;
      text-align: center !important;
      margin-left: 0 !important;
    }
  }
  .content-item-child2 {
    .item-content-img {
      text-align: center !important;
    }
  }
  .android-text {
    width: 100%;
    margin-top: 10px;
  }
}

@media only screen and (min-width: 993px) and (max-width: 1200px) {
  .header,
  .footer {
    padding: 0 100px !important;
  }
}
@media only screen and (min-width: 1201px) and (max-width: 1800px) {
  .header,
  .footer {
    padding: 0 140px !important;
  }
}
@media only screen and (min-width: 1801px) {
  .header,
  .footer {
    padding: 0 140px !important;
  }
  .item-child {
    max-width: 650px !important;
  }
}
</style>
